/**
 * Usonian CSS > Elements > Typography
 */

import { css } from 'styled-components';
import { colors, globals } from 'shared/styles/settings';

export default css`
  hr {
    border-bottom: none;
    border-left: none;
    border-right: none;
    border-top-color: ${colors.grayLighter};
    border-top-style: solid;
    border-top-width: 1px;
  }

  b,
  strong {
    font-weight: 600;
  }

  em {
    background-color: ${colors.yellow};
    border-radius: ${globals.borderRadius};
    display: block;
    font-size: ${globals.fontSizeSmall};
    font-style: normal;
    padding: 0.25rem;
    width: 100%;
  }
`;
